import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import axios from "axios";
import { validaMonto, formatMoneda } from "../../util/varios";
//UI
import { Input } from "../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";

const ModalDepre = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const txtEdad = useRef();
  const txtExcelente = useRef();
  const txtBueno = useRef();
  const txtRegular = useRef();
  const txtMalo = useRef();
  const btnCancela = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    iddepreciacion: "",
    edad: "",
    excelente: "",
    bueno: "",
    regular: "",
    malo: "",
  });
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState("0");
  const blanquear = () => {
    setValues({
      iddepreciacion: "",
      edad: "",
      excelente: "",
      bueno: "",
      regular: "",
      malo: "",
    });
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancela();
  };
  const cancelar = () => {
    props.onHideCancela();
    blanquear();
  };

  const onChange = (e) => {
    e.preventDefault();
    if (e.target.type === "text" || e.target.type === "textarea") {
      e.target.value = e.target.value;
      setValues({ ...values, [e.target.name]: e.target.value });
    } else {
      setValues({ ...values, [e.target.name]: e.target.value });
    }
  };

  const procesarDetalles = () => {
    let endpoint = `${op.conexion}/api/inmueble/actualizardepre`;
    let body;
    setActivate(true);
    body = {
      operacion: operacion,
      nid: operacion === 1 ? 0 : values.iddepreciacion,
      eda: txtEdad.current.value,
      excel: txtExcelente.current.value.replace(/\./g, "").replace(",", "."),
      buen: txtBueno.current.value.replace(/\./g, "").replace(",", "."),
      regu: txtRegular.current.value.replace(/\./g, "").replace(",", "."),
      mal: txtMalo.current.value.replace(/\./g, "").replace(",", "."),
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Registrado Exitosamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Modificado Exitosamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Eliminado Exitosamente",
              icono: "exito",
            });
          }
          props.onHideRender();
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const onChangeValidar = (e) => {
    e.preventDefault();
    let sigue = true;
    if (txtEdad.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La edad no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtEdad.current.focus();
    } else if (txtExcelente.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El porcentaje de Drepreacion Excelente no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtExcelente.current.focus();
    } else if (txtBueno.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El porcentaje de Drepreacion Bueno no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtBueno.current.focus();
    } else if (txtRegular.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El porcentaje de Drepreacion regular no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtRegular.current.focus();
    } else if (txtMalo.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El porcentaje de Drepreacion Malo no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtMalo.current.focus();
    }
    if (sigue) {
      procesarDetalles();
    }
  };
  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");
    return formatMoneda(e);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.tierra);
        }
      }}
    >
      <Modal.Header className="col-12 m-0 p-2 d-flex justify-content-between text-light azulGradiant rounded-top">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Agregar Valor Tipologia"
            : operacion === 2
            ? "Editar Valor Tipologia"
            : operacion === 3
            ? "Eliminar Valor Tipologia"
            : "Consultar Valor Tipologia"}
        </h3>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
          <h4 className="col-12 m-0 mb-2 p-0 text-center">
            Depreciones de Edificaciones ROSS-HEYDECK
          </h4>
          <div className="col-3 m-0 mb-2 p-0">
            <Input label = 'Código'
              disabled
              name="iddepreciacion"
              value={
                values.iddepreciacion != "" ? values.iddepreciacion.trim() : ""
              }
              onChange={onChange}
            />
          </div>
          <div className="col-4 m-0 mb-2 ml-auto p-0 d-flex">
            <Input label = 'Edad'
              ref={txtEdad}
              disabled={operacion === 1 || operacion === 2 ? false : true}
              name="edad"
              value={values.edad != "" ? values.edad : ""}
              maxLength={3}
              onChange={onChange}
            />
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Años
            </span>
          </div>
          <div className="col-6 m-0 mb-2 p-0 d-flex">
            <Input label = 'Porcentaje de Depreciación Excelente:'
              ref={txtExcelente}
              disabled={operacion === 1 || operacion === 2 ? false : true}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
              name="excelente"
              defaultValue={
                values.excelente
                  ? values.excelente != ""
                    ? formatMoneda(
                        values.excelente.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )
                    : ""
                  : ""
              }
              onChange={onChange}
            />
            <span className="input-group-text" id="inputGroup-sizing-sm">
              %
            </span>
          </div>
          <div className="col-6 m-0 mb-2 p-0 pl-2 d-flex">
            <Input label = 'Porcentaje de Depreciación Bueno:'
              ref={txtBueno}
              disabled={operacion === 1 || operacion === 2 ? false : true}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
              name="bueno"
              defaultValue={
                values.bueno
                  ? values.bueno != ""
                    ? formatMoneda(
                        values.bueno.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )
                    : ""
                  : ""
              }
              onChange={onChange}
            />
            <span className="input-group-text" id="inputGroup-sizing-sm">
              %
            </span>
          </div>
          <div className="col-6 m-0 p-0 d-flex">
            <Input label = 'Porcentaje de Depreciación Regular:'
              ref={txtRegular}
              disabled={operacion === 1 || operacion === 2 ? false : true}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
              name="regular"
              defaultValue={
                values.regular
                  ? values.regular != ""
                    ? formatMoneda(
                        values.regular.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )
                    : ""
                  : ""
              }
              onChange={onChange}
            />
            <span className="input-group-text" id="inputGroup-sizing-sm">
              %
            </span>
          </div>
          <div className="col-6 m-0 p-0 pl-2 d-flex">
            <Input label = 'Porcentaje de Depreciación Malo:'
              ref={txtMalo}
              disabled={operacion === 1 || operacion === 2 ? false : true}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
              name="malo"
              defaultValue={
                values.malo
                  ? values.malo != ""
                    ? formatMoneda(
                        values.malo.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )
                    : ""
                  : ""
              }
              onChange={onChange}
            />
            <span className="input-group-text" id="inputGroup-sizing-sm">
              %
            </span>
          </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={onChangeValidar}
        >
          Aceptar
        </SuccessButton>

        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};

export default ModalDepre;
